<pos-app-spinner [show]="isBusy$ | async"></pos-app-spinner>
<div class="container-fluid" *ngIf="{ values: lookupLists$ | async } as lookupLists">
  <div class="text-center">
    <h3 class="pt-3 arb-large-heading">MANAGE REGISTERED USERS</h3>
  </div>
  <div *ngIf="!preSelectedCustomerNumber" class="card shadow-sm mt-4">
    <div class="card-body">
      <div class="row pb-4">
        <div class="col-1 my-auto">
          <label>CUSTOMER</label>
        </div>
        <div class="col-4">
          <pos-app-lib-customer-search
            [customerType]="'billto'"
            (selectNewCustomer)="selectCustomer($event)"
            [forOrderSearch]="true"
            [selectedCustomerName]="
              selectedCustomer ? selectedCustomer?.customerName + ' (' + selectedCustomer?.customerNumber + ')' : selectedCustomerName || ''
            "
            [disabled]="preSelectedCustomerNumber"
            [showSearchIcon]="true"
            [removeCustomerAfterLoad]="true"
            placeHolder="CUSTOMER SEARCH"
            (focus)="isFocus($event)"
          ></pos-app-lib-customer-search>
        </div>
        <div class="col-3">
          <pos-app-lib-customer-external-search
            (selectNewCustomer)="selectCustomer($event)"
            [selectedCustomerName]="
              selectedCustomer ? selectedCustomer?.customerName + ' (' + selectedCustomer?.customerNumber + ')' : selectedCustomerName || ''
            "
            [disabled]="preSelectedCustomerNumber"
            [showSearchIcon]="true"
            [removeCustomerAfterLoad]="true"
            placeHolder="USER SEARCH"
            (focus)="isFocus($event)"
          ></pos-app-lib-customer-external-search>
        </div>
      </div>
    </div>
  </div>
  <div class="card shadow-sm mt-4" *ngIf="selectedCustomer">
    <div class="card-body">
      <div class="row">
        <div class="col-1 my-auto">
          <label>CUSTOMER </label>
        </div>
        <div class="col-7 my-auto">
          {{ selectedCustomer?.customerName + ' (' + selectedCustomer?.customerNumber + ')' }}
        </div>

        <div class="col-4 my-auto">
          <button
            class="btn text-white float-end text-uppercase"
            (click)="goToManagePartner()"
            [disabled]="isBusy$ | async"
          >
            Manage Partner
          </button>
        </div>
      </div>
      <div *ngIf="selectedCustomer && !(isCustomerRegistered$ | async) && !(isBusy$ | async)" class="text-danger mb-4">
        Customer is not registered yet. Go to MANAGE PARTNER to register the customer.
      </div>
    </div>
  </div>
  <div class="card shadow-sm mt-4" *ngIf="selectedCustomer">
    <div class="card-body">
      <form [formGroup]="registerUserForm" class="login-container">
        <div class="row">
          <div class="col-1 my-auto">
            <label for="email">EMAIL</label>
          </div>
          <div class="col-4">
            <input type="email" class="form-control" placeholder="Email" formControlName="email" />
          </div>
          <div class="col-1 my-auto">
            <label for="email">NAME</label>
          </div>
          <div class="col-4">
            <input type="text" class="form-control" placeholder="Name" formControlName="name" />
          </div>
          <div class="col-2">
            <button
              class="btn text-white float-end"
              (click)="registerUser()"
              [disabled]="!registerUserForm.valid || !selectedCustomer || !(isCustomerRegistered$ | async)"
            >
              REGISTER
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card shadow-sm mt-4" *ngIf="selectedCustomer">
    <div class="card-body">
      <form>
        <div class="d-flex flex-row justify-content-around">
          <div class="d-flex">
            <input class="form-check-input" type="checkbox" [formControl]="disabledUserSearch" />
            <label class="ps-3">SHOW DISABLED USERS</label>
          </div>
          <div class="d-flex"><label class="pe-3">FILTER EXISTING USERS</label><input [formControl]="registeredUserSearch" /></div>
        </div>
        <div class="table-responsive tableFixHead">
          <table class="border my-4 table table-bordered">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase text-center">
                  <label>Action</label>
                </th>
                <th scope="col" class="text-uppercase text-center">
                  <label>User</label>
                </th>
                <th scope="col" class="text-uppercase text-center">
                  <label>Created</label>
                </th>
                <th scope="col" class="text-uppercase text-center">
                  <label>Effectivity</label>
                </th>
                <th scope="col" class="text-uppercase text-center">
                  <label>Access</label>
                </th>

                <th scope="col" class="text-uppercase text-center">
                  <label style="min-width: 200px">Default SHIP TO</label>
                </th>
                <th *ngIf="filteredSecurityFunctionList.length > 0" scope="col" class="text-uppercase text-center">
                  <label>Security</label>
                </th>
                <th *ngIf="filteredSecurityFunctionList.length > 0" scope="col" class="text-uppercase text-center">
                  <label>Valid Order Types</label>
                </th>
                <th *ngIf="isARBuAvailable" scope="col" class="text-uppercase text-center">
                  <label>ARB-U Cohort</label>
                </th>
                <th *ngIf="isARBuAvailable" scope="col" class="text-uppercase text-center">
                  <label>Reports To</label>
                </th>
              </tr>
            </thead>
            <tbody (click)="checkFormDirty()">
              <tr *ngFor="let userForm of userForms; let i = index" [formGroup]="userForm" [hidden]="hideRow(i)">
                <td>
                  <div class="d-flex">
                    <mat-icon (click)="save(i)" title="Save" [ngClass]="!userForm.dirty ? 'action-disabled' : ''">save</mat-icon>
                    <span class="px-2"> |</span>
                    <mat-icon (click)="resetPassword(i)" title="Reset Password">settings_backup_restore</mat-icon>
                  </div>
                </td>
                <td>
                  <div>
                    {{ userForm.controls.email.value }}
                  </div>
                  <div>
                    <input type="text" formControlName="name" />
                  </div>
                </td>
                <td>
                  <div>{{ userForm.controls.dateCreated.value }}</div>
                  <div>{{ userForm.controls.createdBy.value }}</div>
                </td>
                <td style="width: 360px">
                  <div class="form-group">
                    <div class="input-group text-uppercase" style="width: 100%">
                      <label style="width: 60px">From: </label>
                      <input
                        class="form-control"
                        name="d1"
                        ngbDatepicker
                        #d1="ngbDatepicker"
                        formControlName="dateEffective"
                        [placement]="'bottom'"
                      />
                      <div class="input-group-append">
                        <button class="btn btn-secondary calendar text-white px-2 py-3" (click)="d1.toggle()" type="button"></button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group text-uppercase" style="width: 100%">
                      <label style="width: 60px">To: </label>
                      <input
                        class="form-control"
                        name="d2"
                        ngbDatepicker
                        #d2="ngbDatepicker"
                        formControlName="dateExpiry"
                        [placement]="'bottom'"
                        [minDate]="minDate"
                      />
                      <div class="input-group-append">
                        <button class="btn btn-secondary calendar text-white px-2 py-3" (click)="d2.toggle()" type="button"></button>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <input class="form-check-input" type="checkbox" formControlName="enableAccess" /><label class="text-uppercase">
                    &nbsp;Access
                  </label>
                  <div class="text-uppercase">Last Login: {{ userForm.controls.dateLastLogin.value }}</div>
                </td>
                <td>
                  <ng-select formControlName="shipTo" style="width: 100%" [clearable]="false">
                    <ng-option *ngFor="let shipTo of selectedCustomer?.shipTos" [value]="shipTo.shipToNumber">
                      {{ shipTo?.shipToName ?? shipTo?.shipToNumber }}
                    </ng-option>
                  </ng-select>
                </td>
                <td *ngIf="filteredSecurityFunctionList.length > 0">
                  <div class="row" style="width: 400px">
                    <div class="" *ngFor="let function of filteredSecurityFunctionList" style="width: 200px">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [name]="function"
                        (change)="toggleFunction(i, $event)"
                        [checked]="hasFunction(i, function)"
                      />
                      &nbsp; &nbsp;<label class="text-uppercase"> {{ function }}</label>
                    </div>
                  </div>
                </td>
                <td *ngIf="filteredSecurityFunctionList.length > 0 && showOrderType(i, filteredSecurityFunctionList)">
                  <div class="row" style="width: 200px">
                    <div class="" *ngFor="let orderType of filteredOrderTypeList; let j = index" style="width: 200px">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [name]="orderType"
                        (change)="toggleOrderType(i,j, $event)"
                        [checked]="hasOrderType(i, orderType?.OrderTypeCode)"
                      />
                      &nbsp; &nbsp;<label class="text-uppercase"> {{ orderType?.OrderTypeDescription }}</label>
                    </div>
                  </div>
                </td>
                <td *ngIf="filteredSecurityFunctionList.length > 0 && !showOrderType(i, filteredSecurityFunctionList)">
                  <div class="d-flex" style="width: 200px; padding: 2px">Maintain Orders security not selected</div>
                </td>

                <td *ngIf="isARBuAvailable" style="min-width: 150px">
                  <ng-select formControlName="ARBuCohort" style="width: 100%">
                    <ng-option *ngFor="let ARBuCohorts of ARBuCohortsList" [value]="ARBuCohorts">
                      {{ ARBuCohorts }}
                    </ng-option>
                  </ng-select>
                </td>
                <td *ngIf="isARBuAvailable" style="min-width: 150px">
                  <ng-select formControlName="ARBuReportsTo" style="width: 100%">
                    <ng-option *ngFor="let user of reportToUserList" [value]="user.email"> {{ user.name }} - {{ user.email }} </ng-option>
                  </ng-select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
    </div>
  </div>
</div>
